import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { Field, Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import { useApi, useWorkspace } from '~/contexts';
import { emptyStringToNull } from '~/utils';
import ExpenseItemDetails from './ExpenseItemDetails';

export default function BulkSetApprovalStatus({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Set Approval Status"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={ExpenseItemDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ statusId: null, reason: '' }}
        onSubmit={async (values) => {
          const body = emptyStringToNull(values);
          if (body.statusId !== 'rejected') {
            body.reason = null;
          }
          return api.www
            .workspaces(workspace.id)
            .expenseAdmin()
            .bulkSetApprovalStatus(ids, body)
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          reason: Yup.string()
            .label('Reason')
            .max(255)
            .when('statusId', { is: 'rejected', then: (schema) => schema.required() }),
          statusId: Yup.string().label('Approval Status').nullable().required(),
        })}>
        {(formik) => {
          return (
            <Form>
              <p>
                Set the approval status of {ids.length} {pluralize('expense item', ids.length)} to:
              </p>

              <Form.Control>
                <Field.ExpenseItemStatusSelect name="statusId" placeholder="Approval Status" />
              </Form.Control>

              {formik.values.statusId === 'rejected' && (
                <Form.Control>
                  <Field.Text name="reason" placeholder="Reason" maxLength={255} />
                </Form.Control>
              )}
            </Form>
          );
        }}
      </Formik>
    </BulkActionModal>
  );
}
